export default "__VITE_ASSET__DLL4S97F__"